import { AxiosResponse } from "axios";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { toast } from "sonner";
import CatchBlockFunction from "../../../../components/hooks/CatchBlockFunction";
import { get, patch, putType } from "../../../../utils/request";
import {
  selectEndDate,
  selectFormData,
  selectOrderBy,
  selectOrderDir,
  selectOrderPageNo,
  selectOrderPageSize,
  selectPageNo,
  selectPageSize,
  selectSearch,
  selectStartDate,
  selectToggleLoading,
} from "./selector";

import { IData } from "../types";
import { actions } from "./slice";
import { userUpdateValidation } from "../../../../components/Common/Validations";

export function* doGetListRequest() {
  yield delay(500);
  try {
    const pageNo: number = yield select(selectPageNo);
    const pageSize: number = yield select(selectPageSize);
    const orderBy: string = yield select(selectOrderBy);
    const orderDir: string = yield select(selectOrderDir);
    const search: string = yield select(selectSearch);
    const buttonLoading: boolean = yield select(selectToggleLoading);
    if (!buttonLoading) {
      yield put(actions.setLoading(true));
    }

    const response: AxiosResponse = yield call(
      get,
      `admin/user/list?pageNo=${pageNo}&pageSize=${pageSize}${
        search.length > 0 ? "&search=" + search : ""
      }${orderBy.length > 0 ? "&orderBy=" + orderBy : ""}${
        orderDir.length > 0 ? "&orderDirection=" + orderDir : ""
      }`
    );
    yield put(actions.setLoading(false));
    yield put(actions.setToggleLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(
      actions.setTotalRow(
        response.data.data.meta ? response.data.data.meta.total : 0
      )
    );
    yield put(actions.setList(response.data.data.results));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    yield put(actions.setToggleLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetByIdRequest(action: { payload: string }) {
  yield delay(500);

  try {
    yield put(actions.setLoading(true));
    const response: AxiosResponse = yield call(
      get,
      `admin/user/get/${
        action.payload !== undefined && action.payload !== null
          ? action.payload
          : ""
      }`
    );
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setDataForm(response.data.data));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}

export function* doUpdateStatusRequest(action: {
  payload: { id: string; callback: any };
}) {
  yield delay(500);
  try {
    yield put(actions.setButtonLoading(true));
    yield put(actions.setToggleLoading(true));
    const response: AxiosResponse = yield call(
      patch,
      `admin/user/update/status/${
        action.payload.id !== undefined && action.payload.id !== null
          ? action.payload.id
          : ""
      }`,
      {}
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action.payload.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}


export function* doUpdateImportantRequest(action: {
  payload: { id: string; callback: any };
}) {
  yield delay(500);
  try {
    yield put(actions.setButtonLoading(true));
    yield put(actions.setToggleLoading(true));

    const response: AxiosResponse = yield call(
      patch,
      `admin/user/update/important/${
        action.payload.id !== undefined && action.payload.id !== null
          ? action.payload.id
          : ""
      }`,
     {}
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action.payload.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}
export function* doGetOrderListRequest(action: { payload: string }) {
  yield delay(500);
  try {
   const pageNo: number = yield select(selectOrderPageNo);
       const pageSize: number = yield select(selectOrderPageSize);
       const startDate: string = yield select(selectStartDate);
       const endDate: string = yield select(selectEndDate);
       const response: AxiosResponse = yield call(
         get,
         `admin/user/get/order/history/${
           action.payload
         }?pageNo=${pageNo}&pageSize=${pageSize}${
           startDate ? "&startDate=" + startDate : ""
         }${endDate ? "&endDate=" + endDate : ""}`
       );
       if (response && !response.data) {
         toast.error(response.data.message);
         return;
       }
       yield put(
         actions.setOrderTotalRow(
           response.data.data.meta ? response.data.data.meta.total : 0
         )
       );
       yield put(actions.setOrderList(response.data.data.results));
     } catch (error: any) {
       yield put(actions.setLoading(false));
       yield put(actions.setToggleLoading(false));
       CatchBlockFunction(error);
     }
}

export function* doUpdateRequest(action: { payload: { callback: any } }) {
  yield delay(500);
  try {
    
    const from: IData = yield select(selectFormData);
    const isValid = userUpdateValidation(from);
    if (!isValid) {
      return;
    }
    yield put(actions.setButtonLoading(true));
    yield put(actions.setToggleLoading(true));
    const response: AxiosResponse = yield call(
      patch,
      `admin/user/update/admin-user/${from._id}`,
      {
        status: from.status,
        importantStatus: from.importantStatus,
      }
    );
    yield put(actions.setButtonLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    toast.success(response.data.message);
    yield call(action.payload.callback());
  } catch (error: any) {
    yield put(actions.setButtonLoading(false));
    CatchBlockFunction(error);
  }
}


export function* UserRepoSaga() {
  yield takeLatest(actions.doGetList, doGetListRequest);
    yield takeLatest(actions.doGetOrderList, doGetOrderListRequest);
  yield takeLatest(actions.doGetById, doGetByIdRequest);
  yield takeLatest(actions.doUpdateStatus, doUpdateStatusRequest);
  yield takeLatest(actions.doUpdateImportant, doUpdateImportantRequest);
    yield takeLatest(actions.doUpdate, doUpdateRequest);
}
